import BasicContentPullQuote from './BasicContentPullQuote';

export { type BasicContentPullQuoteProps } from './BasicContentPullQuote';
export default BasicContentPullQuote;
